import { CONTACT } from "@/constants/testIds";
import { MapPin, Mail, User } from "lucide-react";

/* eslint-disable react/no-unescaped-entities */

const CHANNELS = [
  { label: "General", email: "info@naijacashews.com" },
  { label: "Sales", email: "sales@naijacashews.com" },
  { label: "Marketing", email: "marketing@naijacashews.com" },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid={CONTACT.wrapper}
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c5a059]" />
              <span className="overline">Get in Touch</span>
            </div>
            <h2 className="font-serif-display text-[40px] sm:text-[52px] leading-[1.05] text-[#1a3626] tracking-tight">
              Let's <em className="italic text-[#8b5a2b]">talk cashews.</em>
            </h2>
            <p className="mt-6 text-[15.5px] leading-[1.7] text-[#5c4033] max-w-md">
              Whether you're a retailer, a journalist or simply curious about
              origin-led African food brands — we'd love to hear from you.
            </p>

            <div className="mt-10 space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#1a3626] text-[#c5a059] flex items-center justify-center shrink-0">
                  <User size={16} />
                </div>
                <div>
                  <div className="text-[10.5px] uppercase tracking-[0.24em] text-[#8b5a2b]">
                    Founder
                  </div>
                  <div
                    data-testid={CONTACT.founder}
                    className="mt-0.5 font-serif-display text-[22px] text-[#1a3626]"
                  >
                    Neal Chidi Emegwele
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#1a3626] text-[#c5a059] flex items-center justify-center shrink-0">
                  <MapPin size={16} />
                </div>
                <div>
                  <div className="text-[10.5px] uppercase tracking-[0.24em] text-[#8b5a2b]">
                    Location
                  </div>
                  <div
                    data-testid={CONTACT.location}
                    className="mt-0.5 font-serif-display text-[22px] text-[#1a3626]"
                  >
                    Berlin, Germany
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 min-w-0">
            <div className="rounded-[1.75rem] bg-[#fdfaf4] border border-[#c5a059]/20 divide-y divide-[#c5a059]/15 overflow-hidden">
              {CHANNELS.map((c, i) => (
                <a
                  key={i}
                  data-testid={CONTACT.channel(i)}
                  href={`mailto:${c.email}`}
                  className="group flex items-center gap-3 sm:gap-5 p-4 sm:p-6 hover:bg-[#faf7f2] transition-colors min-w-0"
                >
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#1a3626] text-[#c5a059] flex items-center justify-center shrink-0">
                    <Mail size={14} />
                  </div>
                  <div className="w-16 sm:w-28 shrink-0 text-[10px] sm:text-[10.5px] uppercase tracking-[0.2em] sm:tracking-[0.24em] text-[#8b5a2b]">
                    {c.label}
                  </div>
                  <div className="flex-1 min-w-0 font-sans-body font-medium text-[13px] sm:text-[15.5px] text-[#1a3626] group-hover:text-[#8b5a2b] transition-colors truncate">
                    {c.email}
                  </div>
                  <span className="hidden sm:inline-block text-[#c5a059] opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                    →
                  </span>
                </a>
              ))}
            </div>

            <div className="mt-6 rounded-[1.75rem] bg-[#1a3626] text-[#faf7f2] p-6 sm:p-8 flex flex-col sm:flex-row gap-5 sm:items-center sm:justify-between">
              <div className="min-w-0">
                <div className="text-[10.5px] uppercase tracking-[0.24em] text-[#c5a059]">
                  Website
                </div>
                <div className="mt-1 font-serif-display text-[20px] sm:text-[24px] truncate">
                  www.naijacashews.com
                </div>
              </div>
              <a
                href="#signup"
                className="inline-flex items-center justify-center gap-2 bg-[#c5a059] text-[#1a3626] rounded-full px-5 sm:px-6 py-3 text-[12.5px] sm:text-[13px] font-semibold hover:bg-[#b58f43] transition-colors shrink-0 whitespace-nowrap"
              >
                Join the Launch List →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
